import { Stack, Typography } from '@mui/material'
import { TwinContextSource } from 'api/model'
import { COLORS } from 'app-constants'
import JelledModal from 'components/JelledModal'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'

const VerboseLogModal = ({
  onClose,
  verboseOutput,
  contextSources,
}: {
  onClose: () => void
  verboseOutput: string
  contextSources: TwinContextSource[]
}) => {
  const isMobile = useCheckMobileScreen()

  return (
    <JelledModal
      onClose={onClose}
      isOpen={true}
      modalStyle={{
        backgroundColor: COLORS.PURE_WHITE,
        marginLeft: isMobile ? '16px' : 0,
        marginRight: isMobile ? '16px' : 0,
      }}>
      <Typography mb={4} variant="h4" color="secondary">
        Verbose log for message
      </Typography>

      <Typography
        sx={{
          whiteSpace: 'pre-line',
        }}>
        {verboseOutput}
      </Typography>

      <Typography variant="body1W" mb={2} color="secondary">
        Context sources
      </Typography>

      <Stack spacing={1}>
        {contextSources.map((contextSource, index) => (
          <Stack px={2} py={1}>
            <Typography color="secondary" key={index}>
              Type: {contextSource.type}
            </Typography>
            <Typography color="secondary">Mime type: {contextSource.mime_type}</Typography>
            <Typography color="secondary">Source id: {contextSource.source_id}</Typography>
            <Typography color="secondary">Distance: {contextSource.distance}</Typography>
            {contextSource.name && <Typography color="secondary">Name: {contextSource.name}</Typography>}
          </Stack>
        ))}
      </Stack>
    </JelledModal>
  )
}

export default VerboseLogModal
